import { ReportType } from '../AllocationReport.types';
import { ReportTypeButtons } from './ReportTypeButtons';
import { DirectSalesFramesReportTypeButtonsProps } from './ReportTypeButtons.types';

export const DirectSalesFramesReportTypeButtons: React.FC<DirectSalesFramesReportTypeButtonsProps> = ({
  activeReportType,
  setActiveReportType,
  isDisabled,
}) => {
  if (isDisabled) return null;

  const reportTypeButtons = [
    {
      id: 'not-saved',
      isActive: activeReportType === ReportType.NOT_SAVED,
      isOnClickEnabled: true,
      isVisible: true,
      label: 'Frames',
      onClick: () => setActiveReportType(ReportType.NOT_SAVED),
    },
    {
      id: 'saved',
      isActive: activeReportType === ReportType.SAVED,
      isOnClickEnabled: true,
      isVisible: true,
      label: 'Previously saved frames',
      onClick: () => setActiveReportType(ReportType.SAVED),
    },
  ];

  return <ReportTypeButtons reportTypeButtons={reportTypeButtons} />;
};
